import PasswordResetEmailForm from './PasswordResetEmailForm';

export default PasswordResetEmailForm;
